export const useEnvLinks = () => {
  const startPageUrl = process.env.REACT_APP_FINDER_URL || '/'
  const homepageUrl = process.env.REACT_APP_HOMEPAGE_URL || '/'
  return { startPageUrl, homepageUrl }
}
